export const PURCHASE_LOGO_URL = `https://api.whatsapp.com/send?phone=85266370320&&text=${encodeURIComponent(
  '(APP) How to add Logo'
)}`;
